const NoPage = () => {
    return (
            <div className="container mb-4">
              <h1>Whoops!</h1>
              <p>It looks like that page doesn't exist.</p>
              <p>Please return to the home page and try again.</p>
            </div>
    );
  };
  
  export default NoPage;